<Modal
  title="Change postcode"
  actionTitle="Change"
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
 
  <div class="block">
    <PostcodeInput bind:postcode={newPostcode} bind:isValid />
  </div>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let setLocation : any;

  import PostcodeInput from "../../_components/PostcodeInput.svelte";
  import { uiState } from "../../../lib/uiState";
  import Modal from "../../_components/Modal.svelte";

  let newPostcode = '';

  let isValid = false;

  let errorMessage : string;

  async function apply() {
    if(isValid) {

      const location = await getPostcode(newPostcode);

      setLocation(newPostcode, { longitude: location.longitude, latitude: location.latitude });

      $uiState.activeModal = undefined;
    }
    else {
      errorMessage = 'Postcode not recognised. Try again.'
    }
  }

  async function getPostcode(postcode: string) {
    return fetch(`https://api.postcodes.io/postcodes/${postcode}`)
      .then((res: any) => {
        return res.json();
      })
      .then((payload: any) => {
        return payload.result;
      });
  }

</script>
